<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationpage" id="d7e92">
<h1 class="chapno">
</h1><h2 class="fmh" id="d7e93">
<p class="dedicationtext">
<b>
<i>I dedicate this book, and my life, <br/>to my precious daughter Emily. <br/>I love you more than cookie dough.</i>
</b>
</p>
</h2></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Kime_9781440501951_epub_ded.vue?0f1fc6ce